import ErrorPage from "@modules/layout/error/ErrorPage";
import * as Sentry from "@sentry/react";
import { createBrowserRouter } from "react-router";
import App from "./App";
import MantineProviders from "./config/MantineProviders";
import Modals from "./modals/Modals";
import { buildFullRouteTree } from "./router/AppRoutes";

const AppWithModals = () => (
  <MantineProviders>
    <Sentry.ErrorBoundary fallback={<ErrorPage />}>
      <App />
      <Modals />
    </Sentry.ErrorBoundary>
  </MantineProviders>
);

const router = createBrowserRouter(buildFullRouteTree(<AppWithModals />), {
  future: {
    v8_middleware: true,
    v8_splitRouteModules: true,
    v8_passThroughRequests: true,
    v8_trailingSlashAwareDataRequests: true,
  },
});

export default router;
